<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { mapGetters } from 'vuex'

const colors = [
  '#ff7675', // red
  '#fdcb6e', // blue
  '#0984e3', // green
]

export default {
  props: [
    'items',
    'type',
    'selectedKey',
  ],

  computed: {
    ...mapGetters({
      getCategoryNameById: 'getCategoryNameById',
    }),
    categories () {
      return this.items.reduce((acc, cur) => {
        cur.categories.map((item) => item.catId).forEach((catId) => {
          if (!acc.includes(catId)) {
            acc.push(catId)
          }
        })
        return acc
      }, [])
    },
    barChartLineChartOption () {
      const series = this.categories.map((catId, index) => {
        return {
          data: this.items.map((item) => {
            const result = item.categories.find((itemPaymentMethod) => (
              itemPaymentMethod.catId === catId
            ))
            return result ? result[this.selectedKey] : null
          }),
          type: this.type,
          stack: 'a',
          name: this.getCategoryNameById(catId) || this.$t('apps.reports.message.unspecifiedcategory'),
          label: {
            show: true,
            formatter: (params) => [null, '-', 0].includes(params.value) ? '' : params.value,
          },
          color: colors[index],
        }
      })
      return {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          selectedMode: true,
          type: 'scroll',
        },
        xAxis: {
          type: 'category',
          data: this.items.map((item) => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: series,
      }
    },
    pieChartOption () {
      return {
        color: colors,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            label: {
              show: true,
              formatter (param) {
                return param.name + ' (' + param.percent + '%)'
              },
            },
            data: this.categories.map((catId) => {
              return {
                value: this.items.reduce((acc, cur) => {
                  const total = cur.categories.reduce((_acc, _cur) => {
                    if (_cur.catId === catId) {
                      _acc += _cur[this.selectedKey]
                    }
                    return _acc
                  }, 0)
                  return acc + total
                }, 0),
                name: this.getCategoryNameById(catId) || this.$t('apps.reports.message.unspecifiedcategory'),
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    option () {
      if (this.type === 'bar' || this.type === 'line') {
        return this.barChartLineChartOption
      }
      return this.pieChartOption
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportPosCategoryChart.vue